// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"353":"contact","594":"about"}[chunkId] + "." + {"353":"af7073c3","594":"93b90154"}[chunkId] + ".js";
};